'use client'

import { useServerInsertedHTML } from 'next/navigation'
import { useRef } from 'react'

// Insert before instrumentation-client.ts and hydration, outside React's managed tree.
export function FlushPublicEnv({ script }: { script: string }) {
    const hasInsertedRef = useRef(false)

    useServerInsertedHTML(() => {
        // Streaming may invoke this callback more than once.
        if (hasInsertedRef.current) return null
        hasInsertedRef.current = true
        return <script dangerouslySetInnerHTML={{ __html: script }} />
    })

    return null
}
